import O1HD from "../../../../engines/gameEngine";
import spendMode from "../../spendMode";
import weChatPrefab from "../weChatPrefab/weChatPrefab";

const {ccclass, property} = cc._decorator;

@ccclass
export default class redPacketChallege extends cc.Component {

    @property({type:cc.Node,displayName:"聊天content"})
    itemContent:cc.Node = null;

    @property({type:cc.Prefab,displayName:"自己说话节点"})
    meTalkPrefab:cc.Prefab = null;

    @property({type:cc.Prefab,displayName:"对方说话预制体"})
    sideTalkPrefab:cc.Prefab = null;

    @property({type:cc.ScrollView,displayName:"scrollView"})
    scrollView:cc.ScrollView = null;

    subMoney:number = 0;

    onLoad(){
        this.countDown = this.initCountDown;
        this.startTalk();
    }
   
    moneyArr:number[] = [
        null,
        5200,
        10000,
        100000,
        200000,
        1000000
    ];

    sideChat:string[] = [
        "大侄子 发的好",
        "叔叔，谢谢你的红包",
        "恭喜发财啊",
        "祝你在兔年幸福安康",
        "我又抢到一个小的",
        "赶紧再发一个",
        "不要停啊！",
        "继续",
        "在这里炫富是吧！我被红包吵醒了",
        "我居然一个都没有！哭！",
        "一打开全是空的！",
        "红包发我多少,你就瘦多少！",
        "可以用钱解决的事情，就不要用话解决"
    ]

    @property({type:cc.SpriteFrame,displayName:"NPC头像"})
    NPCHeads:cc.SpriteFrame[] = [];

    @property({type:cc.SpriteFrame,displayName:"主角头像"})
    roleHead:cc.SpriteFrame = null;

    canClick:boolean = true;
    initCountDown:number  = 90;
    countDown:number = 90;

    allMoney:number = 0;

    @property({type:cc.Label,displayName:"倒计时文本"})
    lb_countDown:cc.Label = null;

    startTalk(){
        let sideTalkStr:string = "快发几个红包让大家开心开心";
        let sideTalk:cc.Node = cc.instantiate(this.sideTalkPrefab);
        let ss = sideTalk.getComponent(weChatPrefab);
        ss.setChat(sideTalkStr);
        this.itemContent.addChild(sideTalk);
        this.startCountDown();
        this.updateChoose();
        this.showChoose();
    }

    startCountDown(){
        this.schedule(this.subTime,1);
    }

    stopCountDown(){
        this.unschedule(this.subTime);
    }

    subTime(){
        if(this.countDown>0){
            this.countDown --;
        }else{
            this.stopCountDown();
            // 结束
            O1HD.getModules().uiControlModule.showDialogBox("事件结果",`发红包共花费${this.allMoney}元`,false);
            this.node.destroy();
            this.node.removeFromParent();
        }
        this.updateCountDown();
    }
    
    updateCountDown(){
        this.lb_countDown.string = this.countDown.toString();
    }

    randMoney:number = 0;

    async sideTalk(){
        let index:number = Math.floor(Math.random()* this.sideChat.length);
        let chats:string = this.sideChat[index];
        let talkPrefab:cc.Node = cc.instantiate(this.sideTalkPrefab);
        let ts = talkPrefab.getComponent(weChatPrefab);
        ts.setChat(chats);
        ts.changeHead(this.NPCHeads[index]);
        // 设置NPC头像

        this.itemContent.addChild(talkPrefab);
        this.scrollView.scrollToBottom(0.2);
        await new Promise<void>(resolve=>{
            this.scheduleOnce(()=>{
                resolve();
            },.5);
        });
        this.updateChoose();
        this.showChoose();
    }

    @property({type:cc.Node,displayName:"chooseItem"})
    chooseNode:cc.Node = null;

    againCount:number = 0;
    maxAgainCount:number = 3;

    round:number = 0;

    updateChoose(){
        let chooses:string[] = [];    
        this.randMoney = Math.floor(Math.random() * 10000);
        chooses = [`发一个${-this.randMoney}`];
        this.chooseNode.children.forEach((n:cc.Node,index:number)=>{
            let lb:cc.Label = n.getChildByName("lb").getComponent(cc.Label);
            if(chooses[index]){
                lb.string = chooses[index];
                n.active = true;
            }else{
                n.active = false;
            }
        });
    }

    showChoose(){
        this.chooseNode.active = true;
    }

    hideChoose(){
        this.chooseNode.active = false;
    }

    lastClickTime:number = 0;

    async onBtnChoose(e:cc.Event.EventTouch,custom:string){
        if(this.countDown >0 && Date.now() - this.lastClickTime > 2000){
            this.lastClickTime = Date.now();
            this.allMoney += this.randMoney;
            spendMode._instance.manage.setGameData({_coin:-this.randMoney},true,e.target);
            let talkPrefab:cc.Node = cc.instantiate(this.meTalkPrefab);
            let ts = talkPrefab.getComponent(weChatPrefab);
            ts.setRedPacket();
            ts.changeHead(this.roleHead);
            this.itemContent.addChild(talkPrefab);
            this.scrollView.scrollToBottom(0.2);
            this.sideTalk();
        }
    }

}
